import { action, atom } from "@reatom/core"
import { ChangeEvent } from "react"
import { is } from "superstruct"
import { onConnect } from "@reatom/hooks"

import { ctx } from "modules/PsyCatalog/common/ctx"
import { CatalogSearchQuery, defaultQuery } from "modules/PsyCatalog/common/searchQuery"
import { sex } from "modules/PsyCatalog/common/searchQuery/schema"
import { Services } from "modules/PsyCatalog/common/services"

export function sexField({ UpdateUrl, CurrentQuery, FieldStatus }: Services) {
    const inputValue = atom<CatalogSearchQuery["sex"]>(CurrentQuery.get().sex)
    const update = action((ctx, value: CatalogSearchQuery["sex"]) => {
        inputValue(ctx, value)
    })

    function onChange(event: ChangeEvent<HTMLSelectElement>) {
        update(ctx, parseValue(event.target.value))
        UpdateUrl.run()
    }

    function parseValue(value: unknown) {
        return is(value, sex) ? value : defaultQuery.sex
    }

    function parseAndUpdate(value: unknown) {
        update(ctx, parseValue(value))
    }

    onConnect(inputValue, () => {
        update(ctx, CurrentQuery.get().sex)
        FieldStatus.setReady("sex")
    })

    return { inputValue, onChange, parseAndUpdate, parseValue }
}
